import React from 'react';
import { useTranslationAPI } from '../../../translations';
import { codes } from '../../../../data/translations';
import { DiscList, ListItem } from '../../../../components/List';
import { FlexGrid } from '../../../../components/FlexGrid';
import { Typography } from '../../../../components/Typography';
import userModuleCodes from '../../../../data/translations/userModuleCodes';

type UserPasswordRules = {
	passwordMinimumLength?: number;
	passwordMaximumAge?: number;
	passwordUniqueness?: number;
};

type UserPasswordRequirementsProps = {
	weak?: boolean;
	title?: string;
	passwordConditionsMessage?: string;
} & UserPasswordRules;

export const UserPasswordRequirements: React.FC<UserPasswordRequirementsProps> = ({
	weak,
	title,
	passwordMaximumAge,
	passwordMinimumLength,
	passwordUniqueness,
	passwordConditionsMessage,
}) => {
	const { translate } = useTranslationAPI();

	return (
		<FlexGrid
			column
			gap='small'
		>
			<Typography>
				{title && `${title} `}
				{passwordConditionsMessage ||
					translate(codes.user.forYourOnlineSafetyWeRequireTheFollowingPasswordConditions)}
			</Typography>
			<DiscList>
				<ListItem>{translate(codes.user.atLeastCharactersLong, [passwordMinimumLength])}</ListItem>
				{!weak && (
					<>
						<ListItem>{translate(codes.user.atLeast1SpecialCharacter)}</ListItem>
						<ListItem>{translate(codes.user.atLeast1AlphabeticCharacter)}</ListItem>
						<ListItem>{translate(codes.user.atLeast1NumericCharacter)}</ListItem>
					</>
				)}
				<ListItem>{translate(codes.user.passwordNotUniqueDescription, [passwordUniqueness])}</ListItem>
				{weak && <ListItem>{translate(userModuleCodes.passwordBlackListValidation)}</ListItem>}
			</DiscList>
			{!weak && <Typography>{translate(codes.user.passwordWillExpireAfter, [passwordMaximumAge])}</Typography>}
		</FlexGrid>
	);
};
